import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import TagList from "./TagList";

const GroupPermissionCards = ({ groups = [], permissionName = {} }) => {
  const { t } = useTranslation();

  if (groups.length === 0) return null;

  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
      {groups.map((group) => (
        <Box
          key={group._id}
          border="1px solid #DDD"
          borderRadius={8}
          p={4}
          bg="white"
        >
          <Text
            fontWeight="700"
            fontSize={15}
            color="#333"
            textTransform="capitalize"
            mb={3}
          >
            {group.name}
          </Text>

          {(group.permissions || []).length === 0 ? (
            <Text fontSize={13} color="#666">
              {t("pages.role_management.no_permissions")}
            </Text>
          ) : (
            <TagList items={group.permissions.map((k) => permissionName[k] || k)} />
          )}
        </Box>
      ))}
    </SimpleGrid>
  );
};

export default GroupPermissionCards;